import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { isNullOrUndefined } from 'util';

import { DropDownService } from '../../../base/util/dropdown.service';
import { DenteArea } from '../../../base/vo/dente-area';
import { DentistaRadiologia } from '../../../base/vo/dentista-radiologia';
import { FiltroNovaGto } from '../../../base/vo/filtro-nova-gto';
import { FormularioOrtodontia } from '../../../base/vo/formulario-ortodontia';
import { NovaGto } from '../../../base/vo/nova-gto';
import { Procedimentos } from '../../../base/vo/procedimentos';
import { NovaGtoService } from '../../nova-gto.service';


@Component({
  selector: 'app-filtro-planos',
  inputs: ['novaGto'],
  templateUrl: './filtro-planos.component.html',
  styleUrls: ['./filtro-planos.component.scss']
})
export class FiltroPlanosComponent implements OnInit, AfterViewInit {

  //#region Atributos
  @Input() novaGto: NovaGto;
  @Output() novaGtoChange: EventEmitter<NovaGto> = new EventEmitter<NovaGto>();
  @Output() mostrarBotaoEvent: EventEmitter<boolean> = new EventEmitter<boolean>(true);

  tipoAtendimentoList: any;
  tipoAtendimento: any;
  dente: any;

  filtro: FiltroNovaGto = new FiltroNovaGto();

  dentesOriginal: any;
  dentesResult: any;
  estadosOriginal: any;
  estadosResult: any;
  procedimentosOriginal: any;
  procedimentosResult: any;
  procedimentoCodigo: number;
  ufRadiologia: any;
  croDentistaRadiologiaInvalid: boolean = false;
  ufRadiologiaInvalid: boolean = false;
  nomeRadiologiaInvalid: boolean = false;
  nomeDentistaRadiologiaInvalid: boolean = false;
  novoDentistaRadiologia: DentistaRadiologia;

  facesOriginal: any;

  facesTemporario: any;
  facesInvalid: boolean = false;
  facesMsgErro: string = '';

  buscarDentesAreasCompletado: boolean = false;
  buscarFacesCompletado: boolean = false;
  radiologiaExecutante: boolean = false;
  primeiraOrtodontia: boolean = false;
  facesAplicavel: boolean = false;
  denteAreaAplicavel: boolean = false;
  isListDente: boolean = false;
  tipoAtendimentoSelecionado: boolean = true;
  // Variaveis selecionar faces
  dataOverlay: boolean = false;
  dataOverlayAnimation: boolean = false;
  //Modal cadastrar prestador
  prestadorNaoEncontrado: boolean = false;
  cadastrarPrestadorModal: boolean = false;

  facesString: string = '';
  minFaces: number = 0;
  maxFaces: number = 0;
  ortodontiaFluxo: number = 0;
  exibeModalOrtodontia = false;
  exibeModalProrrogacaoOrtodontia = false;
  telefoneMask: string = '';
  procedimentoTmpID: number = 0;
  //#endregion

  displayModalLimiteProcedimentos = false;

  constructor(public novaGtoService: NovaGtoService, public dropDownService: DropDownService) { }

  ngOnInit() {
    this.facesTemporario = new Array();
    this.novaGto.primeiraOrtodontia = false;
    this.novaGto.disabledTipoAtendimento = false;
  }

  ngAfterViewInit() {

    if (this.novaGto.listaProcedimentos) {
      this.procedimentoTmpID = this.novaGto.listaProcedimentos.length;
    }

    if (this.novaGto.prorrogacaoOrtodontia) {
      this.initFormularioProrrogacaoOrtodontia();
    }

    if (this.novaGto.beneficiario) {
      this.changeMask(this.novaGto.beneficiario.telefoneCelContato);
    }

    this.novaGtoService.tipoAtendimentoDropdown(this.novaGto.prestExecutante).subscribe(

      data => {
        this.tipoAtendimentoList = data.data;
      },
      error => { console.log('Erro ao carregar tipos de atendimento.') });

    this.dropDownService.getEstados().subscribe(
      data => {
        this.estadosOriginal = data;
      },
      error => { console.log('Erro ao carregar tipos de atendimento.') });
  }

  changeTipoAtendimento(event) {
    this.novaGto.listaProcedimentos = null;
    this.procedimentosOriginal = null;
    this.limparFiltro();
    this.novaGto.dentistaRadiologia = undefined;
    this.novaGto.primeiraOrtodontia = false;
    this.novaGto.formularioOrtodontia = undefined;
    this.isRadiologia();
    this.mostrarBotaoEvent.emit(true);
    this.novaGto.tipoAtendimento = this.tipoAtendimento;

    if (this.tipoAtendimento.id == 3) {
      this.isPrimeiraOrtodontia(this.novaGto.beneficiario.codigo);
    } else {
      this.buscarProcedimentoAutocomplete(this.tipoAtendimento.id);
      this.limparFiltro();
      this.isRadiologia();
    }
  }

  changeDenteSelect(event) {
    if (this.dente == '-1' || this.dente == undefined) {
      this.filtro.dente = undefined;
      this.dente = undefined;
      event.target.value = '0: undefined';
    } else {
      this.filtro.dente = this.dente;
      this.facesAplicavel = this.dente.facesAplicavel;
      if (this.facesAplicavel) {
        this.limparFaces();
        this.buscarFaces(this.filtro.dente.codigo);
      }
    }
  }

  changeDenteAutocomplete(event) {
    if (event !== null && event !== '' && event !== undefined) {
      this.dente = event;
      this.facesAplicavel = event.facesAplicavel;
      if (this.facesAplicavel) {
        this.limparFaces();
        this.buscarFaces(this.filtro.dente.codigo);
      }
    } else {
      this.dente = this.filtro.dente;
    }
  }

  //#region Radiologia
  isRadiologia() {
    if (this.tipoAtendimento != undefined) {
      this.radiologiaExecutante = this.tipoAtendimento.radiologiaExecutante;
    } else {
      this.radiologiaExecutante = false;
    }
  }
  //#endregion

  //#region Ortodontia
  isPrimeiraOrtodontia(codBeneficiario) {
    let cod = codBeneficiario;
    this.novaGtoService.isPrimeiraOrtodontia(codBeneficiario, this.novaGto.prestExecutante).subscribe(
      data => {
        this.limparFiltro();
        this.novaGto.primeiraOrtodontia = data.data.primeiraOrtodontia;
        this.ortodontiaFluxo = data.data.fluxo;

        this.novaGto.formularioOrtodontia = new FormularioOrtodontia();
        this.novaGto.formularioOrtodontia.tipoFormulario = 1;

        if (data.data.procedimento && data.data.procedimento.codigo > 0) {
          this.filtro.procedimento = data.data.procedimento;
          this.procedimentoCodigo = +this.filtro.procedimento.codigo;
          this.denteAreaAplicavel = data.data.procedimento.denteAreaAplicavel;
          this.filtro.dente = new DenteArea(data.data.codigoDentaArea, '');
          this.isListDente = true;
        }

        if (this.ortodontiaFluxo == 1) {
          this.adicionarProcedimento();
          this.novaGtoChange.emit(this.novaGto);
        } else if (this.ortodontiaFluxo == 2) {
          this.exibeModalOrtodontia = true;
        } else if (this.ortodontiaFluxo == 4) {
          this.exibeModalProrrogacaoOrtodontia = true;
        } else {
          this.novaGto.formularioOrtodontia = null;
          this.buscarProcedimentoAutocomplete(this.tipoAtendimento.id);
        }

      },
      error => { console.log('Erro ao carregar primeira GTO.') });
  }

  clickOrtodontiaNovoNao() {
    this.tipoAtendimento = undefined;
    this.tipoAtendimentoSelecionado = false;
    this.ortodontiaFluxo = 0;
    this.exibeModalOrtodontia = false;
    this.exibeModalProrrogacaoOrtodontia = false;
    this.novaGto.primeiraOrtodontia = false;
    this.novaGto.formularioOrtodontia = undefined;
    this.novaGto.prorrogacaoOrtodontia = false;
    this.filtro.procedimento = undefined;
    this.procedimentoCodigo = undefined;
    this.denteAreaAplicavel = false;
    this.filtro.dente = undefined;
    this.isListDente = false;
  }

  clickOrtodontiaNovoSim() {
    this.exibeModalOrtodontia = false;
    this.adicionarProcedimento();
    this.novaGtoChange.emit(this.novaGto);
  }

  clickOrtodontiaProrrogacaoSim() {
    this.novaGto.prorrogacaoOrtodontia = true;
    this.novaGto.formularioOrtodontia = new FormularioOrtodontia();
    this.novaGto.formularioOrtodontia.tipoFormulario = 2;

    this.exibeModalProrrogacaoOrtodontia = false;

    this.adicionarProcedimento();
    this.novaGtoChange.emit(this.novaGto);
  }

  initFormularioProrrogacaoOrtodontia() {
    //Setando atendimento Ortodontia
    this.tipoAtendimento = { id: 3, nome: 'Ortodontia', radiologiaExecutante: false }
    this.novaGto.tipoAtendimento = this.tipoAtendimento;
    this.novaGto.primeiraOrtodontia = true; //apenas para entrar no componente

    //Setando tipo do formulario
    this.novaGto.formularioOrtodontia = new FormularioOrtodontia();
    this.novaGto.formularioOrtodontia.tipoFormulario = 2;

    //Setando procedimento 
    this.filtro.procedimento = new Procedimentos();
    this.filtro.procedimento.codigo = '81000189';
    this.filtro.procedimento.descricao = 'DIAGNOSTICO E PLANEJAMENTO PARA TRATAMENTO ODONTOLOGICO';
    this.procedimentoCodigo = 81000189;
    this.denteAreaAplicavel = true;
    this.filtro.dente = new DenteArea('ASAI', '');
    this.isListDente = true;
    this.adicionarProcedimento();

    //Travando a selecao do tipo de atendimento
    this.novaGto.disabledTipoAtendimento = true;

    //Emit changes
    this.novaGtoChange.emit(this.novaGto);
  }
  //#endregion

  //#region Filtro genérico
  autoCompleteDentes(event) {
    this.dente = this.filtro.dente;
    this.dentesResult = this.dentesOriginal.filter(
      item => item.descricao.toUpperCase().indexOf(event.query.toUpperCase()) !== -1);
  }

  autoCompleteProcedimentos(event) {
    if (this.procedimentosOriginal) {
      this.procedimentosResult = this.procedimentosOriginal.filter(item => item.descricao.toUpperCase().indexOf(event.query.toUpperCase()) !== -1);
    }
  }

  autoCompleteEstados(event) {
    this.estadosResult = this.estadosOriginal.filter(
      item => item.uf.toUpperCase().indexOf(event.query.toUpperCase()) !== -1);
  }

  buscarProcedimentoAutocomplete(tipoAtendimento) {
    this.novaGtoService.buscarProcedimentos(tipoAtendimento, this.novaGto.prestExecutante).subscribe(
      data => {
        this.procedimentosOriginal = data.data;
        this.tipoAtendimentoSelecionado = false;
      },
      error => { console.log('Erro ao carregar lista de procedimentos da GTO.') });
  }

  buscarProcedimentoPorCodigo(codigoProcedimento, tipoAtendimento) {
    this.novaGtoService.buscarProcedimentoPorCodigo(codigoProcedimento, tipoAtendimento, this.novaGto.prestExecutante).subscribe(
      data => {
        //Preenche codigo do procedimento...
        //chamar método que popula tanto um quanto o outro campo de procedimento.
        this.filtro.procedimento = data.data;
        this.denteAreaAplicavel = data.data.denteAreaAplicavel;
        if (this.denteAreaAplicavel) {
          this.dentesOriginal = null;
          this.dente = null;
          this.filtro.dente = null;
          this.buscarDentesAreas(codigoProcedimento);
        }

      },
      error => {
        console.log('Erro ao carregar procedimento.');
        //chamar método para limpar todo o filtro e adicionar mensagem de código não encontrado.
        this.limparFiltro();
      });
  }

  buscarDentesAreas(codigoProcedimento) {
    this.buscarDentesAreasCompletado = false;
    this.novaGtoService.buscarDentesAreas(codigoProcedimento, this.novaGto.prestExecutante).subscribe(
      data => {
        //Carrega autocomplete de dentes...
        this.dentesOriginal = data.data.listDenteArea;
        this.isListDente = data.data.isListDente;
        this.dente = undefined;
        this.buscarDentesAreasCompletado = true;
      },
      error => { console.log('Erro ao carregar dentes/area.') });
  }

  buscarFaces(codigoDenteArea) {
    var teste = codigoDenteArea;
    this.buscarFacesCompletado = false;
    this.novaGtoService.buscarFaces(this.procedimentoCodigo, codigoDenteArea, this.novaGto.prestExecutante).subscribe(
      data => {
        this.facesOriginal = data.data.listFace;
        this.minFaces = data.data.qtdMin;
        this.maxFaces = data.data.qtdMax;
        this.buscarFacesCompletado = true;
      },
      error => { console.log('Erro ao carregar faces.') });
  }

  buscarDentistaRadiologiaBlurUf() {
    if (this.filtro.radiologia.cro && this.ufRadiologia && this.ufRadiologia.uf) {
      this.buscarDentistaRadiologia();
    }
  }

  onClearUf() {
    this.ufRadiologia = undefined;
  }

  buscarDentistaRadiologia() {
    if (this.ufRadiologia && this.ufRadiologia.uf) {
      this.filtro.radiologia.uf = this.ufRadiologia.uf;
    } else {
      this.filtro.radiologia.uf = undefined;
    }

    //por enquanto o nome não participa da busca, e deve ser limpado sempre que a busca for acionada
    this.filtro.radiologia.nome = '';

    this.croDentistaRadiologiaInvalid = false;
    this.ufRadiologiaInvalid = false;
    this.nomeRadiologiaInvalid = false;

    this.novaGtoService.buscarDentistaRadiologia(this.filtro.radiologia).subscribe(
      successResponse => {
        this.filtro.radiologia.nome = successResponse.data[0].nome;
        this.novaGto.dentistaRadiologia = successResponse.data[0];
      },
      errorResponse => {
        this.novaGto.dentistaRadiologia = undefined;
        for (let index = 0; index < errorResponse.error.errors.length; index++) {
          if (errorResponse.error.errors[index].field == "not_found") {
            this.abrirModalDentistaRadiologia();
          } else if (errorResponse.error.errors[index].field == "unknow") {
            console.log(errorResponse.error.errors[index].message);
          } else if (errorResponse.error.errors[index].field == "cro") {
            this.croDentistaRadiologiaInvalid = true;
          } else if (errorResponse.error.errors[index].field == "uf") {
            this.ufRadiologiaInvalid = true;
          }
        }
      });
  }

  procedimentoSelecionado(event, tipoInput) {
    if (tipoInput == 1) {
      if (event !== null && event !== '' && event !== undefined) {
        this.buscarProcedimentoPorCodigo(event, this.tipoAtendimento.id);
      } else {
        this.limparFiltro();
      }
    } else if (tipoInput == 2) {
      if (event !== null && event !== '' && event !== undefined) {
        this.procedimentoCodigo = event.codigo;
        this.filtro.procedimento = event;
        this.denteAreaAplicavel = event.denteAreaAplicavel;
        if (this.denteAreaAplicavel) {
          this.dentesOriginal = null;
          this.dente = null;
          this.filtro.dente = null;
          this.buscarDentesAreas(event.codigo);
        }

      } else {
        this.limparFiltro();
      }
    }
  }

  //Método pra limpar todos os campos do filtro.
  limparFiltro() {
    this.denteAreaAplicavel = false;
    this.facesAplicavel = false;
    this.dentesOriginal = null;
    this.filtro.dente = null;
    this.dente = undefined;
    this.filtro.faces = null;
    if (!this.novaGto.primeiraOrtodontia) {
      this.procedimentoCodigo = null;
      this.filtro.procedimento = null;
    }
  }

  //Método para adicionar procedimento à lista.
  adicionarProcedimento() {
    if (this.novaGto.listaProcedimentos && this.novaGto.listaProcedimentos.length > 5) {
      this.displayModalLimiteProcedimentos = true;

      return;
    }

    if (this.filtroValido()) {
      var procedimento = this.montaProcedimento();

      if (this.novaGto.listaProcedimentos != undefined) {
        var lista = this.deepClone(this.novaGto.listaProcedimentos);
        lista.push(Object.assign({}, procedimento));
        this.novaGto.listaProcedimentos = this.deepClone(lista);
      } else {
        this.novaGto.listaProcedimentos = new Array<Procedimentos>();
        this.novaGto.listaProcedimentos.push(Object.assign({}, procedimento));
      }

      if (!this.novaGto.primeiraOrtodontia) {
        this.novaGto.disabledTipoAtendimento = true;
      }

      this.novaGtoChange.emit(this.novaGto);

      this.limparFiltro();
    }
  }

  montaProcedimento() {
    var procedimento = new Procedimentos();

    procedimento = this.filtro.procedimento;
    if (this.denteAreaAplicavel) {
      procedimento.denteArea = this.filtro.dente.codigo;
    }
    if (this.facesAplicavel) {
      procedimento.faces = this.filtro.faces;
    }
    procedimento.linha = ++this.procedimentoTmpID;
    return procedimento;
  }

  filtroValido() {
    if (this.procedimentoCodigo == null || this.procedimentoCodigo == 0 || this.procedimentoCodigo == undefined) {
      return false;
    }

    if (this.filtro.procedimento == null || this.filtro.procedimento == undefined) {
      return false;
    }

    if (((!this.isListDente) && this.denteAreaAplicavel && (this.dente == null || this.dente == undefined || this.dente == '')) ||
      (this.isListDente && this.denteAreaAplicavel && (this.filtro.dente == null || this.filtro.dente == undefined || this.filtro.dente == ''))) {
      //adicionar mensagem de erro => Obrigatório dente/Área
      return false;
    }

    if (this.filtro.faces != null && this.filtro.faces.length == 0 && this.facesAplicavel) {
      return false;
    }

    if (this.facesAplicavel && (this.filtro.faces == null || this.filtro.faces == undefined) && this.facesInvalid) {

      return false;
    }

    return true;
  }

  // Exibe ou esconde o datepicker
  dataOverlayVisivel(isVisible: boolean) {

    if (isVisible) {

      this.dataOverlay = isVisible;
      setTimeout(() => {
        this.dataOverlayAnimation = isVisible;
      }, 1);

    } else {

      this.dataOverlayAnimation = isVisible;
      setTimeout(() => {
        this.dataOverlay = isVisible;
      }, 200);

    }
  }

  aplicarFaces() {
    var codigo = ''

    this.facesTemporario.forEach(element => {
      codigo += element.codigo + ', ';
    });
    codigo = codigo.slice(0, -2);
    this.facesString = codigo;

    if (this.facesTemporario.length > this.maxFaces || this.facesTemporario.length < this.minFaces) {
      this.facesInvalid = true;
      this.facesMsgErro = 'Quantidade mínima ' + this.minFaces + ', máxima ' + this.maxFaces;
      this.filtro.faces = null;
    } else {
      this.facesInvalid = false;
      this.facesMsgErro = '';
      this.filtro.faces = this.facesTemporario;
    }
    this.dataOverlayVisivel(false);
  }

  limparFaces() {
    this.facesTemporario = new Array();
    this.facesInvalid = false;
    this.facesMsgErro = '';
    this.filtro.faces = this.facesTemporario;
    this.facesString = '';
    this.dataOverlayVisivel(false);
  }

  existeNaLista(face) {
    var existe = this.facesTemporario.filter(
      item => item.codigo.toUpperCase().indexOf(face.codigo.toUpperCase()) !== -1);
    if (existe.length > 0) {
      return true;
    }
    return false;
  }

  clickFace(face) {
    let existe = this.existeNaLista(face);
    if (existe) {
      //remove da lista
      this.facesTemporario = this.deepClone(this.facesTemporario.filter(
        item => item.codigo.toUpperCase().indexOf(face.codigo.toUpperCase()) == -1));
    } else {
      //adiciona na lista
      var lista = this.deepClone(this.facesTemporario);
      lista.push(Object.assign({}, face));
      this.facesTemporario = this.deepClone(lista);
      // this.facesTemporario.push(face);
    }
  }

  deepClone(oldArray: Object[]) {
    let newArray: any = [];
    oldArray.forEach((item) => {
      newArray.push(Object.assign({}, item));
    });
    return newArray;
  }

  abrirModalDentistaRadiologia() {
    this.prestadorNaoEncontrado = true;
    this.cadastrarPrestadorModal = false;
  }

  abrirModalNovoDentistaRadiologia() {
    this.cadastrarPrestadorModal = true;
    this.nomeDentistaRadiologiaInvalid = false;
    this.novoDentistaRadiologia = new DentistaRadiologia();
    this.novoDentistaRadiologia.cro = this.filtro.radiologia.cro;
    this.novoDentistaRadiologia.uf = this.filtro.radiologia.uf;
    this.novoDentistaRadiologia.nome = '';
  }

  /*
  OBSERVACAO: ele apenas sera cadastrado ao salvar a nova GTO.
  */
  cadastrarNovoDentistaRadiologia() {
    if (!this.novoDentistaRadiologia.nome
      || this.novoDentistaRadiologia.nome.trim() == '') {
      this.nomeDentistaRadiologiaInvalid = true;
      return;
    }

    //Para salvar na GTO
    this.novaGto.dentistaRadiologia = new DentistaRadiologia();
    this.novaGto.dentistaRadiologia.codigo = 0;
    this.novaGto.dentistaRadiologia.cro = this.novoDentistaRadiologia.cro;
    this.novaGto.dentistaRadiologia.uf = this.novoDentistaRadiologia.uf;
    this.novaGto.dentistaRadiologia.nome = this.novoDentistaRadiologia.nome.trim();

    //Para exibicao na tela
    this.filtro.radiologia.nome = this.novaGto.dentistaRadiologia.nome;

    this.prestadorNaoEncontrado = false;
  }

  limparDentistaRadiologia() {
    this.filtro.radiologia.cro = null;
    this.filtro.radiologia.uf = null;
    this.filtro.radiologia.nome = null;
    this.ufRadiologia = null;
    this.nomeRadiologiaInvalid = false;
    this.novaGto.dentistaRadiologia = new DentistaRadiologia();
  }

  onFecharPrestadorModal(visible: boolean) {
    if (!visible) {
      if (isNullOrUndefined(this.filtro.radiologia.nome)
        || this.filtro.radiologia.nome.trim() == '') {
        this.nomeRadiologiaInvalid = true;
      }
    }
  }

  onTelefoneInput(event: any) {
    if (event) {
      this.changeMask(event.target.value);
    }
  }

  changeMask(tel: string) {
    if (tel) {
      let tmp = tel.replace(/ /g, '').replace('-', '').replace('(', '').replace(')', '');
      if (tmp.length == 10) {
        this.telefoneMask = '(00) 0000-00000';
      } else if (tmp.length > 10) {
        this.telefoneMask = '(00) 0 0000-0000';
      } else {
        this.telefoneMask = '(00) 0000-0000';
      }
    } else {
      this.telefoneMask = '(00) 0000-0000';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/nova-gto/planos-tratamento/filtro-planos/filtro-planos.component.ts